import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ExperienceModel } from '../../models/experience.model';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ExperienceService } from '../../Experience.service';
import { EmbedVideoService } from 'ngx-embed-video';
import { StarRatingColor } from 'src/app/shared/mat-star-rating/mat-star-rating.component';
import { ExperienceEvaluationsModel } from '../../models/experience-evaluations.model';
import { ExperienceCommentsModel } from '../../models/experience-comments.model';

@Component({
    selector: 'my-experinces',
    templateUrl: 'my-experinces.component.html',
    styleUrls: ['my-experinces.component.scss']
})
export class MyExperincesComponent implements OnInit {
    experiences:ExperienceModel[]=[];
    backupexperiences:ExperienceModel[]=[];
    Menuoption = 'center';
    Settingicon = true
    addForm:FormGroup;
    page = 1;
    constructor(private experienceService:ExperienceService, 
        private embedService: EmbedVideoService,
        private fb:FormBuilder
        
        ){}
    ngOnInit(): void {
        this.addForm = this.createAddForm();
        this.addObject = new ExperienceModel()
        this.experienceService.GetMyExperiences()
        .subscribe(data => {
            this.experiences = data;
            if(this.experiences && this.experiences.length > 0){
                this.experiences.forEach(element => {
                    element.embedServiceHtml = this.embedService.embed(element.videoUrl,
                        {
                            query: { portrait: 0, color: '333' },
                            attr: { width: 200, height: 100 }
                        });
                });
                this.playMainVideo(this.experiences[0]);
                this.backupexperiences=[...this.experiences]
                this.collectionSize = this.backupexperiences.length;
                this.getPremiumData();
            }
        
        })
    }
    mainVideo;
    video:any;
    playMainVideo(mainPost){
        debugger;
        if(this.mainVideo){
            this.mainVideo.embedServiceHtml = this.embedService.embed(this.mainVideo.videoUrl,
                {
                    query: { portrait: 0, color: '333' },
                    attr: { width: 200, height: 100 }
                });
            this.experiences.push(this.mainVideo)
        }
        this.mainVideo = mainPost;
        this.mainVideo.embedServiceHtml = this.embedService.embed(mainPost.videoUrl,
            {
                query: { portrait: 0, color: '333' },
                attr: { width: '100%', height: 500 }
            });
      
        var i = this.experiences.findIndex(x=>x.id == mainPost.id);
        if(i > -1){
            this.experiences.splice(i,1);
        }
    }
    pageSize = 4;
    collectionSize = 0;
    imageUrl: any = 'assets/images/testuser.jpg';
    getPremiumData(){
    
        this.experiences =  this.backupexperiences
         .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
         
       }
       evaluation:ExperienceEvaluationsModel={};
       rating:number = 3;
       starCount:number = 5;
       starColor:StarRatingColor = StarRatingColor.accent;
       starColorP:StarRatingColor = StarRatingColor.primary;
       starColorW:StarRatingColor = StarRatingColor.warn;
       onRatingChanged(rating){
        console.log(rating);
        this.rating = rating;
        this.evaluation.date=new Date();
        this.evaluation.experienceId = this.mainVideo.id;
        this.evaluation.numberOfStars = this.rating;
        this.experienceService.Evaluate(this.evaluation)
        .subscribe(result=>{

        })
      }
      experienceComment:ExperienceCommentsModel={};
      myComment='';
      comment(){
        this.experienceComment.date=new Date();
        this.experienceComment.experienceId = this.mainVideo.id;
        this.experienceComment.comment = this.myComment;
        this.experienceService.Comment(this.experienceComment)
        .subscribe(result=>{
            this.myComment = '';
            if(result.id > 0){
                this.mainVideo.comments.push(result);
            }
        })
      }
      addObject:ExperienceModel=new ExperienceModel();
      videoUploadedurl:any=null;
      createAddForm():FormGroup{
        return this.fb.group({
            id:[this.addObject.id],
            comments:[this.addObject.comments],
            date:[this.addObject.date],
            evaluations:[this.addObject.evaluations],
            numberOfComments:[this.addObject.numberOfComments],
            numberOfStars:[this.addObject.numberOfStars],
            title:[this.addObject.title],
            travelerId:[this.addObject.travelerId],
            description:[this.addObject.description],
            videoUrl:[this.addObject.videoUrl],

        })
      }

      uploadedVideo=false;
      onUploadFinished($event){
        debugger
        this.videoUploadedurl = $event
            console.log('$event',$event)
            console.log('this.videoUploadedurl',this.videoUploadedurl)
            this.addForm.controls['videoUrl'].setValue(this.videoUploadedurl);
            this.uploadedVideo = true;
      }
    @ViewChild('modal') modal: ElementRef;

      saveExperience(){

        this.addObject = this.addForm.getRawValue();
        console.log('this.addObject ',this.addObject )
        this.experienceService.insert(this.addObject)
        .subscribe(data => {
            if(data == "Plase Login"){
                
            }
            else{
                this.addObject = new ExperienceModel();
                this.addForm = this.createAddForm();
                window.location.reload();
                
            }
        })
      }
}
